import xs from "xstream"
import {div, button, table, tbody, tr, th, td, img, input, label} from "@cycle/dom"
import * as R from "ramda"

const getPhotoUpload = (loadedImage) => {
	const url =  R.propOr("", "src", loadedImage)

	return div(".panel-body.panel-primary",[
		div(".memberIdView", [
			div(".photoFrame", {attrs: {style: `background-image: url(${url})`}}, [
				url === "" ? div(["写真を選択してください"]) : null,
			]) ,
			div(".cardFrame", [
				div(".fs-6", [
					div(".caution", ["※注意※"]),
					div(".message", "ご本人確認ができる写真をお選びください。"),
					div(".message", "写真の中心部が正方形に切り出されます"),
					div(".message", "ご登録後、事務局にて確認後の反映になります。"),
				]),
			]),
			div(".mt-4.d-grid.gap-2.d-md-flex.justify-content-md-center", [
        label(".btn.btn-block.btn-info.col-md-3", {attrs: {for: "photoInput"}}, ["写真選択"]),
        button(".btn.btn-block.btn-success.btnUpload.col-md-3", {attrs: {disabled: url === ""}}, ["登録する"]),
        button(".btn.btn-block.btn-danger.btnReturn2.col-md-3",["戻る"]),
			]),
		]),
		input("#photoInput", {attrs: {type: "file", accept: "image/*", style: "width: 1px; height: 1px; opacity: 0"}}),
	])
}

const getErrorMsg = (msg) => {
	return div(".photoResult", [
		div(".mt-2.fs-6", [
			div(".caution", ["※登録できませんでした。※"]),
			div(".message.mt-2", msg),
		]),
	])
}
const getOkMsg = () => {
	return div(".photoResult", [
		div(".mt-2.fs-6", [
			div(".success", ["※証明写真を登録しました。※"]),
			div(".message.mt-2", ["事務局にて、確認後の反映となります。"]),
			div(".message", ["反映まで時間がかかることをご了承ください。"]),
		]),
	])
}

const getPhotoResult = (loadResp) => {
	const status = R.prop("status", loadResp)
	const msg = R.prop("message", loadResp)
	return div(".panel-body.panel-primary",[
		div(".memberIdView", [
			status === 0 ? getOkMsg() : getErrorMsg(msg),
			div(".mt-2.d-grid.d-md-flex", [
        button(".btn.btn-block.btn-danger.btnReturn2.col-md-4",["戻る"]),
			]),
		]),
	])
}

export const view = (loadedImage$, loadResp$) => xs.combine(loadedImage$, loadResp$)
	.map(([loadedImage, loadResp]: [any, any]) => {
		if (loadResp === null) {
			return getPhotoUpload(loadedImage)
		} else {
			return getPhotoResult(loadResp)
		}
	})
